import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import { GatsbyImageProps } from 'gatsby-plugin-image';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { imageMatteTv } from 'src/theme/basic-styles';
import { CMS_THEME } from '../../common/enums';
import { CardLink } from '../Link';

type Props = {
  onClick?: React.EventHandler<React.MouseEvent>;
  drupalId?: string;
  cmsTheme?: CMS_THEME;
  image?: React.ReactElement<GatsbyImageProps> | null;
  link: string;
  title: string;
};

const styles = pdsTv({
  slots: {
    iconCard:
      '!pds-h-full pds-cursor-pointer !pds-border-none pds-text-center pds-no-underline hover:pds-cursor-pointer focus:pds-underline active:pds-underline',
    wrapper: 'pds-flex pds-flex-col pds-gap-3.5 pds-p-0 pds-py-4',
  },
});

const IconCard = function ({ image, link, title, cmsTheme = CMS_THEME.LIGHT, ...props }: Props) {
  const { iconCard, wrapper } = React.useMemo(() => styles(), []);

  const imageMatteStyles = React.useMemo(
    () =>
      imageMatteTv({
        theme: cmsTheme,
        className:
          'pds-relative pds-mx-auto pds-flex pds-w-full pds-overflow-hidden pds-rounded-circle pds-pt-[100%]',
      }),
    [cmsTheme],
  );

  const handleGA = (item: string) => {
    sendIt({
      event: 'nav_click',
      eventParams: {
        nav_item: item,
        nav_type: 'category_icons',
      },
    });
  };
  return (
    <CardLink
      to={link}
      theme={cmsTheme}
      analytics={false}
      className={iconCard()}
      onClick={() => handleGA(title)}
      {...props}
    >
      <div className={wrapper()}>
        {image && (
          <div className={imageMatteStyles}>
            {React.cloneElement(image, {
              imgStyle: {
                left: '50%',
                position: 'absolute',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
              },
              style: {
                height:
                  image?.props?.objectFit === 'contain' ? 'calc(50% * 1.4142 - 0.625rem)' : '100%', // Circle inscribed with a square with a 10px margin.
                left: '50%',
                position: 'absolute',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width:
                  image?.props?.objectFit === 'contain' ? 'calc(50% * 1.4142 - 0.625rem)' : '100%',
              },
            })}
          </div>
        )}
        <div>{title}</div>
      </div>
    </CardLink>
  );
};

export default IconCard;
